export default "__VITE_ASSET__BmWCIt6___"